import {AnyColumnJson} from "./ColumnJson"
import {AnyTemplateJson} from "./TemplateJson"
import {ModelPlatform} from "../enum/ModelPlatform"
import QualityCheckJson from "./QualityCheckJson"
import {TogetherTrainingType} from "../enum/TogetherTrainingType"

export type AnyCustomModelJson = OpenAiCustomModelJson | TogetherCustomModelJson

export interface CustomModelJson {
    id: string
    name: string
    platform: ModelPlatform
    template: AnyTemplateJson
    platformId: string | null
    qualityCheck: QualityCheckJson
    created: string
    projectFields: AnyColumnJson[] | null
    trainingRowCount: number | null
    validationRowCount: number | null
    numberOfEpochs: number
    started: string | null
    completed: string | null
    failed: string | null
    failedReason: string | null
}

export interface CustomModelSummaryJson {
    id: string
    name: string
    platform: ModelPlatform
    template: AnyTemplateJson
}

export interface OpenAiCustomModelJson extends CustomModelJson {
    platform: ModelPlatform.OPEN_AI
    trainingFileId?: string
    validationFileId?: string
    baseModelName: string
    model?: string
    batchSize: number | null
    learningRateMultiplier: number | null
    promptLossWeight: number | null
}

export interface TogetherCustomModelJson extends CustomModelJson {
    platform: ModelPlatform.TOGETHER
    trainingFileId?: string
    validationFileId?: string
    baseModelName: string
    outputModelName?: string
    batchSize: number
    learningRate: number
    trainingType: TogetherTrainingType
    loraRank: number | null
    loraAlpha: number | null
    loraDropout: number | null
}

export function resolveBaseModelName(customModel: AnyCustomModelJson) {
    return customModel.baseModelName
}

export function resolveOpenAiPlaygroundUrl(customModel: OpenAiCustomModelJson) {
    const mode = customModel.baseModelName.includes("gpt-3.5") ? "chat" : "complete"
    return `https://beta.openai.com/playground?mode=${mode}&model=${encodeURIComponent(customModel.model ?? "")}`
}

export function resolveCustomModelExternalUrl(customModel: AnyCustomModelJson) {
    if (customModel.platform !== ModelPlatform.OPEN_AI) {
        return null
    }
    if (!customModel.completed) {
        return `https://platform.openai.com/finetune/${customModel.platformId}`
    }
    return resolveOpenAiPlaygroundUrl(customModel)
}
